<!--  -->
<template>
  <div>
    <div>
      <div class="serch_box search_box">
        <el-input v-if="tableData.length!==0 && tableData[0].relation_type === 1" v-model="query.keywords" clearable style="width:200px;margin-right:10px" placeholder="请输入员工id/名称" />
        <el-input v-if="tableData.length!==0 && tableData[0].relation_type === 2" v-model="query.group_chat_keywords" clearable style="width:200px;margin-right:10px" placeholder="请输入群组id/名称" />
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <!-- <el-table-column
        prop="id"
        label="id"
        align="center"
        width="100"
      /> -->
      <el-table-column
        prop="name"
        label="员工名字"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.relation_type===1">
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工编号(企业名称)"
        align="center"
        width="280"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.relation_type===1">
            <div class="sdwr">
              <el-tooltip class="item" effect="dark" :content="scope.row.relation_id+'('+scope.row.corp_name+')'" placement="top">
                <div class="gecawe"> {{ scope.row.relation_id }}（ {{ scope.row.corp_name }}</div>）
              </el-tooltip>
            </div>
            <!-- {{ scope.row.relation_id }}（{{ scope.row.corp_name }}） -->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_nickname"
        label="群名称(id)"
        align="center"
        width="280"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.relation_type===2" style="display: flex;flex-wrap: wrap;justify-content: center;">
            <div class="sdwr">
              <el-tooltip class="item" effect="dark" :content="scope.row.name+'('+scope.row.relation_id+')'" placement="top">
                <div class="gecawe"> {{ scope.row.name }}（ {{ scope.row.relation_id }}</div>）
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.status == 2" class="el-icon-success defaultr" />
          <i v-if="scope.row.status == 3" class="el-icon-error stopew" />
          <i v-if="scope.row.status == 4" class="el-icon-error fasrw" />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="200"
      />
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="created_time_text"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="pushreacd(scope.row.temporary_push_bind_no)">推送记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-button type="primary" size="mini" @click="unbind">解绑</el-button>

    <el-dialog
      title="推送记录"
      :visible.sync="dialogVisiblepush"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :append-to-body="true"
      width="80%"
    >
      <pushrecord ref="pushrecordview" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { temporaryPushbindList, temporaryPushunBinding } from '@/api/officialaccount.js'
import pushrecord from './pushrecord.vue'
export default {
  components: { PaginationRight, pushrecord },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        page_size: 10,
        keywords: null,
        sp_temporary_no: null,
        group_chat_keywords: null
      },
      selectlist: [],
      selectlistsend: [],
      group_selection: null,
      dialogVisiblepush: false,
      namearr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    rowKey(row) {
      return row.id
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.send_time_passed != false // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    async list() {
      this.loading = true
      const data = await temporaryPushbindList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.group_chat_keywords = null
      this.list()
    },
    send(id, group_selection) {
      this.query.sp_temporary_no = id
      this.group_selection = group_selection
      this.list()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    unbind() {
      console.log(this.selectlist)
      if (this.selectlist.length === 0) {
        this.$message.error('请选择需要解绑的人员')
        return
      }
      this.namearr = []
      this.namearr = this.selectlist.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
        return itemr.name
      })
      this.$confirm(`确定解绑 ${this.namearr.join(',')} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (this.group_selection === 1) {
          this.selectlistsend = []
          this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
            // eslint-disable-next-line eqeqeq
            return itemr.relation_id
          })
        } else {
          this.selectlistsend = []
          this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
            // eslint-disable-next-line eqeqeq
            return itemr.relation_id
          })
        }
        temporaryPushunBinding({
          sp_temporary_no: this.query.sp_temporary_no,
          relation_id: this.selectlistsend
        }).then((res) => {
          this.$emit('updata')
          this.$message({
            message: '解绑成功',
            type: 'success'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })

      // if (this.selectlist[0].group_selection === 3) {
      //   this.selectlistsend = []
      //   this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
      //   // eslint-disable-next-line eqeqeq
      //     return itemr.group_chat_id
      //   })
      //   const data = await removeBind({
      //     sp_strategy_no: this.query.sp_strategy_no,
      //     group_chat_ids: this.selectlistsend
      //   })
      //   this.$emit('updata')
      //   this.$message({
      //     message: '解绑成功',
      //     type: 'success'
      //   })
      //   console.log('data', data)
      // } else {
      //   this.selectlistsend = []
      //   this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
      //   // eslint-disable-next-line eqeqeq
      //     return itemr.employee_no
      //   })
      //   const data = await sprremoveBind({
      //     sp_strategy_no: this.query.sp_strategy_no,
      //     employee_nos: this.selectlistsend
      //   })
      //   this.$emit('updata')
      //   this.$message({
      //     message: '解绑成功',
      //     type: 'success'
      //   })
      //   console.log('data', data)
      // }
    },
    async pushreacd(temporary_push_bind_no) {
      this.dialogVisiblepush = true
      this.$nextTick(() => {
        this.$refs.pushrecordview.send(temporary_push_bind_no)
      })
      // const data = await temporaryPushpushRecord({

    // })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serch_box{
  margin-bottom: 10px;
}
.sdwr{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gecawe{
  display: inline-block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
